import React, { Suspense } from 'react';
import { lazily } from 'react-lazily';
import { type LearnMoreType } from 'src/context/store/app-provider';
import { usePromoDecision } from 'src/hooks/use-widget-decisions';

const { NonLtfSnippet } = lazily(() => import('../non-ltf-snippet'));
const { LtfSnippet } = lazily(() => import('../ltf-snippet'));
const { DefaultSnippet } = lazily(() => import('../default-snippet'));

interface Props {
  onClick: (type: LearnMoreType) => void;
}

export const Snippet = ({ onClick }: Props) => {
  const decision = usePromoDecision();

  if (decision.snippet === 'ltf') {
    return (
      <Suspense key="ltf" fallback={null}>
        <LtfSnippet onClick={() => onClick(decision.learnMore)} />
      </Suspense>
    );
  }

  if (decision.snippet === 'default') {
    return (
      <Suspense key="default" fallback={null}>
        <DefaultSnippet onClick={() => onClick(decision.learnMore)} />
      </Suspense>
    );
  }

  return (
    <Suspense key="non-ltf" fallback={null}>
      <NonLtfSnippet onClick={() => onClick(decision.learnMore)} />
    </Suspense>
  );
};
